import i18n from 'i18next'
import React, {useState} from 'react'
import PropTypes from 'prop-types'
import Modal from '#components/m/Modal'
import Headline from '#components/a/Headline'
import Button from '#components/a/Button'
import ErrorModal from '#components/m/ErrorModal'
import { useAuth } from 'oidc-react'

export function BerufwechselConfirmModal(props) {
  const [berufwechselError, setBerufwechselError] = useState(null)
  const auth = useAuth()

  const confirmBerufwechsel = async () => {
    try {
      await props.apiCallback()
      setTimeout(auth.signOutRedirect, 0)
    } catch (e) {
      if (e.isExpectedError) {
        setBerufwechselError(e)
      } else {
        throw e
      }
    }
  }

  const berufwechselFailed = berufwechselError !== null

  return (
    <div className="dashboard-note__button-box">
      <ErrorModal
        headline={i18n.t('berufwechsel_confirmation_failed_headline')}
        text={i18n.t(berufwechselError?.message)}
        error={berufwechselError}
        showModal={berufwechselFailed}
        buttonText={i18n.t('berufwechsel_error_confirmation_button')}
        contentModifier="berufswechsel_failed"
        onButtonClick={() => {
          setBerufwechselError(null)
        }}
      />
      <Modal
        hasCloseButton
        confirmCallback={confirmBerufwechsel}
        confirmText={i18n.t('berufwechsel_confirmation_dialog_confirm')}
        confirmLoadingText={i18n.t('berufwechsel_confirmation_dialog_confirm_loading')}
        closeButtonText={i18n.t('berufwechsel_confirmation_dialog_cancel')}
        trigger={
          <Button
            testid="showBerufswechselModalButton"
            text={props.buttonText}
            disabled={props.disabled}
            variant="primarydark"
          />
        }
      >
        <div className="berufewechsel-modal__content">
          <Headline modifier="article" importance={2} text={props.headlineText} />
          {props.children}
        </div>
      </Modal>
    </div>
  )
}

BerufwechselConfirmModal.propTypes = {
  disabled: PropTypes.bool,
  headlineText: PropTypes.string,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  apiCallback: PropTypes.func,
}
